import { BaseService } from "./BaseService";
import { Configuration } from "Configuration";
import { MenuClient, Menu } from "./Client/ServiceClient";

/**
 * Service which gets the menu.
 * @hidden
 */
export class MenuService extends BaseService {

    /**
     * Get menu items.
     */
    public get(): Promise<Menu> {
        let client = new MenuClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();

        return this.handleResult(
            new Promise<Menu>((resolve, reject) => {
                client.get(
                    (res) => resolve(res),
                    (exception, reason) => reject(exception)
                );
                // cancellationTokenSource.token.onCancelled((reason) => {
                //     xhr.abort();
                //     reject(reason);
                // });
            })
        );
    }
}
